let actions = {

};

export default actions;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/user/actions.js